var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7394 12.2404L18.4494 7.95044C11.2493 13.4404 6.50936 21.9004 6.08936 31.5004H12.0894C12.5394 23.5504 16.6194 16.5904 22.7394 12.2404ZM59.9094 31.5004H65.9094C65.4594 21.9004 60.7194 13.4404 53.5494 7.95044L49.2894 12.2404C55.3494 16.5904 59.4594 23.5504 59.9094 31.5004Z",
    fill: "#F30002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1988 64.88C36.8088 64.97 36.4188 65 35.9988 65C32.6688 65 29.9988 62.3 29.9688 59H41.9688C41.9688 59.84 41.8188 60.62 41.5188 61.34C40.7388 63.14 39.1488 64.46 37.1988 64.88Z",
    fill: "#F30002"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_15154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 33C54 23.79 49.08 16.08 40.5 14.04V12C40.5 9.51 38.49 7.5 36 7.5C33.51 7.5 31.5 9.51 31.5 12V14.04C22.89 16.08 18 23.76 18 33V48L12 54V57H60V54L54 48V33Z",
    fill: "#161614"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_15154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 31C12 17.7452 22.7452 7 36 7C49.2548 7 60 17.7452 60 31V66H12V31Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.db33c7233af596ce8056a976ed8263aa.svg";
export { ForwardRef as ReactComponent };